import React from "react";
import styled from "@emotion/styled";
import { MyPendingProjectRequests } from "./MyPendingRequests";
import { RoleStats } from "./RoleStats";
import { MyWorkCard } from "./MyWorkCard";
import { PayrollAdminInfo } from "./PayrollAdminInfo";
import { ThirdPartyInvoiceUnreviewedCount } from "./ThirdPartyInvoiceUnreviewed";
import { IfAuthorized } from "~/components/IfAuthorized";
import { MenuAuthorizations } from "~/gql/types2";
import { OfficeBillingCard } from "~/home/OfficeBillingCard";

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 18px;
`;

// Each column is stretched to the height of the taller one; without align-content the grid
// stretches its rows to fill that height and the extra space opens up between the cards.
const Column = styled.div`
  display: grid;
  gap: 18px;
  align-content: start;
`;

export const HomePage: React.FC = () => {
  return (
    <Layout>
      <Column>
        <RoleStats />
        <MyPendingProjectRequests />
        <ThirdPartyInvoiceUnreviewedCount />
        <PayrollAdminInfo />
      </Column>
      <Column>
        <IfAuthorized menu={MenuAuthorizations.OfficeBillingReport}>
          <OfficeBillingCard />
        </IfAuthorized>
        <MyWorkCard />
      </Column>
    </Layout>
  );
};
